var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_1287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2409 20.1667H9.45312C9.41009 20.1528 9.36601 20.1424 9.32131 20.1357C8.10605 20.0464 6.93859 19.7607 5.84308 19.2261C2.72845 17.7069 0.833275 15.2449 0.157552 11.84C0.0840278 11.4687 0.0525174 11.089 0 10.7135V9.45312C0.0157552 9.32393 0.0336113 9.19526 0.047791 9.06607C0.285169 6.8866 1.11967 4.96972 2.59121 3.34168C4.14782 1.62121 6.07363 0.549332 8.36549 0.1523C8.72628 0.0898048 9.09075 0.0472656 9.45312 0H10.7135C10.7633 0.0142912 10.814 0.0249972 10.8653 0.0320356C12.4282 0.1502 13.8903 0.597647 15.2274 1.41534C17.8438 3.01555 19.4461 5.32631 20.0123 8.34763C20.0805 8.71526 20.1173 9.08603 20.1667 9.45523V10.6763C20.1236 11.0197 20.0984 11.3663 20.0354 11.7061C19.3831 15.2108 17.4487 17.7321 14.2322 19.2702C13.8047 19.4745 13.3478 19.6179 12.8857 19.7954V12.3143H15.0441C15.1534 11.4661 15.2605 10.6379 15.3708 9.78293H12.8851C12.8792 9.74991 12.875 9.7166 12.8725 9.68315C12.8725 9.11859 12.8647 8.5535 12.8794 7.98947C12.8956 7.33773 13.2291 7.00004 13.8835 6.97168C14.3294 6.95225 14.7763 6.9617 15.2222 6.95855H15.427V4.65829C14.6355 4.64621 13.8551 4.59737 13.0789 4.63781C12.6673 4.66767 12.2652 4.77587 11.8941 4.95659C10.8343 5.45865 10.3685 6.37981 10.2876 7.50263C10.2388 8.1822 10.2671 8.86808 10.2608 9.55081C10.2608 9.62696 10.2608 9.70311 10.2608 9.80131H8.10763V12.3169H10.2608V12.5516C10.2608 15.0196 10.2608 17.4879 10.2608 19.9566C10.2598 20.0243 10.2477 20.0958 10.2409 20.1667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_1287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.1667,
    height: 20.1667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ef98741b990c5e7d41f81b8b5d265a23.svg";
export { ForwardRef as ReactComponent };